// extracted by mini-css-extract-plugin
export default {"TSI__activeAccounts__mainContainer":"ActiveAccounts_TSI__activeAccounts__mainContainer__jnQSv"};